<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Plug-ins do navegador Trinka</h1>
                        <p>A extensão de Navegador Trinka corrige e aprimora seus textos e mensagens em seus sites favoritos
                            em tempo real! Escreva com segurança e sucesso em tempo real!</p>
                        <div id="safariBrowser">
                            <button title="Em breve para Safari">
                                <img src="../../../assets/images/safari_logo.png" alt="safari logo">Em breve</button>
                            <div class="downloadForSafari">
                                <h2>Baixar para:</h2>
                                <ul>
                                    <li>
                                        <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                            title="Download for Chrome">
                                            <img src="../../../assets/images/NewChromeFicon.svg" alt="chrome">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai/" title="Download for Firefox">
                                            <img src="../../../assets/images/NewFirefoxFicon.svg" alt="firefox">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" title="Download for Edge">
                                            <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div id="BrowserGoogleChromeSection">
                            <div class="browserPluginButton">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                    class="buttonGoogleChrome" id="BrowserChromeButton">
                                    <b>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">
                                    </b>
                                    <i>Instalar para Chrome</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai/" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox"> Também disponível para Firefox
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> Também disponível para Edge
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div id="BrowserFirefoxSection">
                            <div class="browserPluginButton">
                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton">
                                    <b>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>Instalar para Firefox</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> Também disponível para Chrome
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> Também disponível para Edge
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div id="BrowserEdgeBrowserSection">
                            <div class="browserPluginButton">

                                <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                    class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                    <b>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>Instalar para Edge</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> Também disponível para Chrome
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai/" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Chrome"> Também disponível para Edge
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/BrowserPlugin_banner.png" alt="broweser plugin">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="brandlogo_heading">
                        <h2>Os plug-ins da Trinka funcionam em:</h2>
                    </div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/google-docs.png" alt="googl">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client_inners">
                                    <img src="../../../assets/images/authorea.png" alt="authorea">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/researchgate.png" alt="researchgate">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client_inners">
                                    <img src="../../../assets/images/medium.png" alt="medium">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/writing-cooprative.png" alt="writing">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/evernote.png" alt="evernote">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/notion.png" alt="notion">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/linked-in.png" alt="linked">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/twitter.png" alt="twitter">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/gmail.png" alt="gmail">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="viewfullList">
                        <!-- <a routerLink="/brand-list">View Full List</a> -->
                        … e muitos mais
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Principais características do Plug-in do navegador Trinka</h2>
                        <div class="HeadingSubLine"></div>
                        <p>A Trinka está disponível como uma extensão para o seu navegador favorito para ajudá-lo a escrever
                            melhor em qualquer lugar, a qualquer hora. Obtenha correções e sugestões em tempo real. Mesmo
                            assim, ele automaticamente verifica todas as suas alterações para que você não perder nada.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/realTimeEditing_icon.svg" alt="realtime">
                        <h3>Edição em tempo real</h3>
                        <p>Não há necessidade de esperar que o editor sugira correções. Trinka faz correção enquanto você escreve.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AddtoDictionary.svg" alt="add to dictionary">
                        <h3>Adicionar ao dicionário</h3>
                        <p>Adicione suas próprias palavras ao “Meu Dicionário” e a Trinka não as sinalizará como erros ortográficos
                            em sua escrita futura.</p>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards" data-aos="fade-up" data-aos-duration="1500">
                        <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="download track changes">
                        <h3>Word Count Reduction</h3>
                        <p>Trinka makes wordy phrases concise to make your writing impactful and comply with journal guidelines.</p>
                    </div>
                </div> -->
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DataSecurityIcon.svg" alt="data security">
                        <h3>Enviar para Edição Humana</h3>
                        <p>Precisa de um especialista humano para editar seu manuscrito final? Envie-o para os editores especialistas
                            do Enago diretamente do editor Trinka.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <h2>Trinka Plugins do navegador: Trabalha onde você faz</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">

                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Correção gramatical no Google Docs</h2>
                            <p>Quer escrever melhor no Google Docs e corrigir todos os erros gramaticais sem complicações?</p>
                            <p>Adicione a extensão do navegador da Trinka e obtenha correções gramaticais e ortográficas em
                                tempo real e aprimoramentos de linguagem no Google Docs. </p>
                            <!-- <a href="#">
                                Read More
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/google-doc-ss.jpg" alt="google docs" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                            <div class="col-sm-12">
                                <div class="writerBox_heading">
                                    <h2>How to write better on Authorea?</h2>
                                </div>
                            </div>
                        </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/authorea-ss.jpg" alt="authorea" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Como escrever melhor no Authorea?</h2>
                            <p>Você usa o Authorea para as suas necessidades de escrita? Se sim, uma ferramenta de correção
                                gramatical para melhorar a qualidade da sua escrita é imprescindível!</p>
                            <p>Use o plug-in de navegador da Trinka para corrigir erros gramaticais em tempo real e escrever
                                melhor no Authorea. </p>
                            <!-- <a href="#">
                                Read More
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2>Correct your writing on Evernote</h2>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Corrija sua escrita no Evernote</h2>
                            <p>Aprimore a qualidade da sua escrita no Evernote. A Trinka, nossa ferramenta de escrita baseada
                                em IA, corrige a gramática e faz aprimoramentos de linguagem em tempo real.</p>
                            <p>A extensão do navegador da Trinka é totalmente compatível com o Evernote e, com este plug-in
                                fácil de usar, você pode revisar e editar sem esforço seu texto. </p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                                </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/evernote-ss.jpg" alt="evernote" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2>Write better on Medium with Trinka</h2>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/medium-ss.jpg" alt="medium" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Escreva melhor no Medium com a Trinka</h2>
                            <p>Você escreve blogs no Medium? Então, não perca os recursos de edição fornecidos pelo plug-in
                                de navegador gratuito da Trinka.</p>
                            <p>Trinka corrige sua escrita quanto à gramática, tom, pontuação, estrutura da frase, etc., e melhora
                                a qualidade geral da escrita que impressionará os leitores no Medium. </p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="../../../assets/images/ReadMoreArrow.png" alt="read more">
                                </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="browser_plugin_cta">
        <div class="container">
            <div class="row">
                <div class="col-lg-12" id="BrowserGoogleChromeSection_cta">
                    <div class="trinka_cloud_banner_text">

                        <div class="browserPluginButton">
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                class="buttonGoogleChrome" id="BrowserChromeButton">
                                <b>
                                    <img src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">
                                </b>
                                <i>Instalar para Chrome</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserFirefoxSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton_cta">
                                <b>
                                    <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>Instalar para Firefox</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserEdgeBrowserSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">

                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                <b>
                                    <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>Instalar para Edge</i>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Use o Trinka em outros aplicativos</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/pt/trinkacloud">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/wordplugin">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word Plug-in</h3>

                                        </div>
                                    </a>
                                </li>
                                <!-- <li>
                                    <div class="app_name_content" routerLink="/browser-plugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/other_Apps_browser.svg" alt="bowser plugin">
                                        <h3>Plugins do navegador</h3>
                                    </div>
                                </li> -->
                                <li>
                                    <a href="https://www.trinka.ai/pt/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">Empresas</h3>
                                            <span style="font-size: 11px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>